import { Textarea as MantineTextarea, TextareaProps as MantineTextareaProps } from "@mantine/core";
import { forwardRef, Ref } from "react";

import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";

import classes from "./InputStyles.module.css";

export type TextareaProps = MantineTextareaProps;

export const Textarea: React.FunctionComponent<TextareaProps> = forwardRef(
  (props, ref: Ref<HTMLTextAreaElement> | undefined) => {
    return (
      <MantineTextarea
        ref={ref}
        onFocus={selectInputOnFocus}
        {...props}
        classNames={{
          input: classes.input,
          label: classes.label,
        }}
      />
    );
  },
);
